<template>
    <div>
        <vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Foreground Put</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Movement Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-table multiple v-model="selected" :data="details" stripe hoverFlat pagination max-items="20">
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        {{ tr.line_id }}
                    </vs-td>

                    <vs-td>
                        {{ tr.product_code }}
                    </vs-td>

                    <vs-td>
                        {{ tr.description_1 }}
                    </vs-td>

                    <vs-td>
                        {{ tr.pack_id }}
                    </vs-td>

                    <vs-td>
                        {{ tr.batch }}
                    </vs-td>

                    <vs-td>
                        {{ tr.expired_date }}
                    </vs-td>
                    
                    <vs-td>
                        {{ tr.base_qty }}
                    </vs-td>

                   <vs-td>
                        {{ tr.base_uom }}
                    </vs-td>

                    <vs-td>
                        {{ tr.stock_type }}
                    </vs-td>

                    <vs-td>
                        {{ tr.location_type }}
                    </vs-td>

                    <vs-td>
                        {{ tr.location_code }}
                    </vs-td>

                    <vs-td>
                        {{ tr.storage_unit }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>

        <vs-popup
            :active.sync="putModal"
            title="Item Detail"
            fullscreen
            v-if="currentData.length > 0"
        >
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Line ID" v-model="currentData[0].draft_line_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Product ID" v-model="currentData[0].product_code" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Description" v-model="currentData[0].description_1" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" v-model="currentData[0].description_2" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Stock Type" v-model="currentData[0].stock_type" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label="Base Qty" :value="currentData[0].total_qty" disabled/>
                        </div>
                        <div class="vx-col md:w-1/2">
                            <vs-input class="w-full" label=" " v-model="currentData[0].base_uom" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-10" style="padding-left: 10px; padding-right: 10px">
                <vs-card title="Item Details" class="p-4 mb-6">
                    <div slot="header" class="flex flex-wrap items-center justify-between">
                        <div class="flex items-center">
                            <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="deleteData">Delete</vs-button>
                            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="addData">Add</vs-button>
                        </div>
                        <div class="flex items-center">
                            <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" @click="skipData">Skip</vs-button>
                            <vs-button color="success" class="btn mb-4 md:mb-0 mr-1" @click="saveData">Save</vs-button>
                        </div>
                    </div>
                    <div style="overflow-x: auto">
                        <vs-table multiple v-model="modalSelected" :data="modals[currentIndex]" stripe hoverFlat>
                            <template slot="thead">
                                <vs-th>Line ID</vs-th>
                                <vs-th>Pack ID</vs-th>
                                <vs-th>Batch</vs-th>
                                <vs-th>Exp. Date</vs-th>
                                <vs-th style="width: 10%">Qty</vs-th>
                                <vs-th>UoM</vs-th>
                                <vs-th>Location ID</vs-th>
                                <vs-th>Storage Unit</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-show="tr.data_status != 'delete'">
                                    <vs-td>
                                        {{ tr.line_id }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.pack_id }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.batch }}
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.expired_date }}
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.base_qty"/>
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.base_uom }}                                    
                                    </vs-td>
                                    
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="tr.location_id"
                                            width="100%"
                                            autocomplete
                                            @input="changeLocation(tr)"
                                            @input-change="searchLocation($event)"
                                        >
                                            <vs-select-item v-for="(item, index) in locations" :key="index" :value="item.id" :text="item.label"/>
                                        </vs-select>
                                    </vs-td>

                                    <vs-td>
                                        {{ tr.storage_unit }}
                                    </vs-td>

                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </vs-card>
            </div>
        </vs-popup>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    props: {
        type: {
            type: String
        }
    },
    data() {
        return {
            data: {
                id: '',
                reference: '',
                movement_date: null,
                drafts: []
            },
            selected: [],
            isLoading: false,
            details: [],
            modals: [],
            currentIndex: 0,
            locations: [],
            currentData: [],
            putModal: false,
            modalSelected: []
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        addData() {
            const current = this.currentData
            const total_qty = current[0].total_qty
            let current_qty = 0
            
            current.map(item => {
                current_qty += parseInt(item.base_qty)
            });

            let add_qty = parseInt(total_qty - current_qty)

            if(add_qty > 0) {
                let newData = Object.assign({}, current[0])

                newData.base_qty = add_qty
                newData.id = null
                newData.location_type = null
                newData.location_code = null
                newData.storage_unit = null
                newData.line_id = this.currentData.length + 1

                this.currentData.push(newData)
            }
        },
        searchLocation(event) {
            this.$http.post('inventories/availablelocations', { location_code: event.target.value }).then(res => {
                console.log(res)
                this.locations = []
                this.locations = res.data.map(item => {
                    item.label = `${item.location_code}`

                    return item
                })
            });
        },
        deleteData() {
            if(this.modalSelected.length == this.currentData.length) {
                this.$vs.notify({   
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon: 'icon-x',
                    text: `Can't delete all data`
                })
            }
            else {
                this.modalSelected.map(item => {
                    this.currentData.map((data, index) => {
                        if(item.line_id == data.line_id) {
                            this.currentData.splice(index, 1)
                        }
                    })
                })

                this.modalSelected = []
                this.assignLineId()
            }
        },
        skipData() {

        },
        assignLineId() {
            this.currentData.map((data, index) => {
                data.line_id = index + 1
            })
        },
        assignDetailsLineId() {
            this.details.map((data, index) => {
                data.line_id = index + 1
            })
        },
        saveData() {
            // this.isLoading = true;
            let url = 'inventories/updateputlocation';
            let type = null;

            const drafts = this.currentData.map(item => {
                return {
                    id: item.draft_ids || item.id,
                    inventory_id: item.inventory_id,
                    base_qty: item.base_qty,
                    location_id: item.location_id,
                    storage_unit: item.storage_unit
                }
            });

            if(this.$props.type == 'fgr') {
                type = 'FGR';
            }
            else if(this.$props.type == 'DO-REVERSE') {
                type = 'DO-REVERSE';
            }
            else if(this.$props.type == 'Stock Transfer') {
                type = 'ST'
            }

            const data = {
                id: this.currentData[0].draft_id,
                detail_id: this.currentData[0].draft_detail_id,
                drafts: drafts,
                draft_type: 'PUT',
                type: type
            }

            this.$http.post(url, data)
            .then(res => {
                console.log(res)
                this.isLoading = false
                this.putModal = false

                res.data.draft.map(item => this.details.push(item))
                this.selected = this.details
                this.assignDetailsLineId()
                
                this.currentIndex++
                setTimeout(() => {
                    this.showModal()
                }, 300)
            })
            .catch(error => this.handleError(error))
        },
        changeLocation(data) {
            const index = this.locations.findIndex(i => i.id === data.location_id)
            const location = this.locations[index]

            data.location_type = location.location_type
            data.location_code = location.location_code
        },
        back() {
            let name = null;
            let id = this.$route.params.id
            if(this.$props.type == 'Stock Transfer') {
                name = 'stock-transfer-view';
            }
            else if(this.$props.type == 'fgr') {
                name = 'fg-receiving-view';
            }

            this.$router.push({
                name: name,
                params: {
                    id: id
                }
            });
        },
        submitForm() {
            let error = false

            const details = []

            if(!this.selected.length) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No data selected'
                });
                
                return false
            }

            this.selected.map(item => {
                if(!item.inventory_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + ' - No location assigned'
                    })

                    error = true
                }
                else {
                    details.push(item.id)
                }
            })

            if(error) {
                return false
            }
            else {
                this.isLoading = true
                let url = 'inventories/savedraft'

                const dataSend = {
                    id: this.$route.params.id,
                    movement_date: this.data.movement_date,
                    type: this.$props.type,
                    details: details
                }

                if(this.$props.type == 'fgr') {
                    url = 'valueaddedservice/fgreceiving/saveputdraft';
                }
                else if(this.$props.type == 'DO-REVERSE') {
                    url = 'inventories/saveputdraft';
                }

                this.$http.post(url, dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.back();
                })
                .catch(error => this.handleError(error))
            }
        },
        showModal() {
            const index = this.currentIndex

            if(!this.modals[index]) {
                this.currentData = []
                return false
            }
            else {
                const data = {
                    type: 'stock_transfer',
                    id: this.modals[index][0].draft_detail_id
                }

                this.currentData = this.modals[index]
                this.assignLineId()

                this.$http.post('inventories/availablelocations', {
                    id: this.currentData.map(i => i.location_id)
                })
                .then(res => {
                    this.putModal = true
                    this.locations = []
                    this.locations = res.data.map(item => {
                        item.label = `${item.location_code}`

                        return item
                    })

                    this.putModal = true

                    setTimeout(() => {
                        this.isLoading = false
                    }, 300)
                })
                .catch((error) => this.handleError(error))
            }
        }
    },
    mounted() {       
        if(!this.$route.params.data) {
            return this.$router.go(-1);
        }

        this.$route.params.data.draft.map((d, i) => d.line_id = i + 1)

        this.data = this.$route.params.data
        
        this.data.movement_date = new Date()

        let groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
            const value = obj[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {})

        let groupById = groupBy('draft_detail_id')
        let partitionData = groupById(this.data.draft)

        Object.values(partitionData).map(item => {
            item.map(d => d.total_qty = this.$_.sumBy(item, 'base_qty'))
            this.modals.push(item)
        })

        this.isLoading = true
        this.showModal()
    }
}
</script>